import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { ParameterType, CategoryType } from 'types';
import ActionCreators from 'actions/ActionCreators';
import { createControlFactory } from 'components/Controls';
import Tip from 'components/TipControl';
import Checkbox from 'components/CheckboxControl';
import InputControl from 'components/InputControl';
import { arrayContainsValue } from 'core/utils.js'

import './AdditionalParametersPane.scss';

class AdditionalParametersPane extends Component {

    static propTypes = {
        parameters: PropTypes.objectOf(ParameterType).isRequired,
        selectedCategory: PropTypes.instanceOf(CategoryType).isRequired,
    }

    constructor(props) {
        super(props);
        this.Control = createControlFactory(ActionCreators.updateParameter);
    }

    state = {
        holdStuffChecked: false,
        insuranceCargoCost: '',
    }

    componentWillMount() {
        if (this.props.parameters.hold_stuff && this.props.parameters.hold_stuff.value) {
            this.setState({holdStuffChecked: this.props.parameters.hold_stuff.value});
        }
    }

    _onHoldStuffTimeChange = (event, value) => {
        value = event.target.value;

        if (value === '' || ( value.length <= 3 && /^\d+$/.test(value) )) {

            var hasDays = value ? true : false;

            this.setState({
                holdStuffChecked: hasDays
            });

            ActionCreators.updateParameter({
                'hold_stuff_time': value,
                'hold_stuff': hasDays
            });
        }
    }

    _onHoldStuffChange = () => {
        this.setState({
            holdStuffChecked: !this.state.holdStuffChecked
        }, () => {

            ActionCreators.updateParameter({
                'hold_stuff': this.state.holdStuffChecked
            });

            if (!this.state.holdStuffChecked) {
                ActionCreators.updateParameter({
                    'hold_stuff_time': ''
                });
            }
        });
    };

    _onInsuranceCargoCostChange = (event) => {
        const insuranceCargoCost = parseInt(event.target.value);

        if (!isNaN(insuranceCargoCost) && insuranceCargoCost >= 0) {
            this.setState({ insuranceCargoCost });
        } else {
            this.setState({
                insuranceCargoCost: '',
            });
        }
    }

    render() {
        const { parameters } = this.props;

        var passing = null;
        if (parameters['passing']) {
            passing = (
                <div className="AdditionalParametersPane-field">
                    <this.Control
                        type="checkbox"
                        attribute={ parameters['passing'] }
                        label={ parameters['passing'].title }
                        name={ parameters['passing'] } />
                    <Tip className="ParametersScreen-helpBox"
                         label={parameters['passing'].tip}  />
                </div>
            );
        }

        var outsized = null;
        if (parameters.outsized) {
            outsized = (
                <div className="AdditionalParametersPane-field">
                    <this.Control
                        key="10"
                        type="checkbox"
                        label={ parameters.outsized.title }
                        attribute={parameters.outsized}/>
                </div>
            );
        }

        var holdStuff = null;
        if (parameters.hold_stuff && parameters.hold_stuff_time) {
            holdStuff = (
                <div className="AdditionalParametersPane-field">
                    <Checkbox
                        label="Необходимо хранение груза"
                        value={this.state.holdStuffChecked}
                        onChange={this._onHoldStuffChange}/>
                    <InputControl
                        value={parameters.hold_stuff_time.value || ''}
                        className="AdditionalParametersPane-days"
                        placeholder="Дней"
                        maxLength="3"
                        onChange={this._onHoldStuffTimeChange}/>
                </div>
            );
        }

        var tir = null;
        if (parameters.tir) {
            tir = (
                <div className="AdditionalParametersPane-field">
                    <this.Control
                        key="7"
                        type="checkbox"
                        label={ parameters.tir.title }
                        attribute={parameters.tir}/>
                </div>
            );
        }

        var crm = null;
        if (parameters.crm) {
            crm = (
                <div className="AdditionalParametersPane-field">
                    <this.Control
                        key="8"
                        type="checkbox"
                        label={ parameters.crm.title }
                        attribute={parameters.crm}/>
                </div>
            );
        }

        var t1 = null;
        if (parameters.t1) {
            t1 = (
                <div className="AdditionalParametersPane-field">
                    <this.Control
                        key="11"
                        type="checkbox"
                        label={ parameters.t1.title }
                        attribute={parameters.t1}/>
                </div>
            );
        }

        var adr = null;
        if (parameters.adr) {
            adr = (
                <div className="AdditionalParametersPane-field AdditionalParametersPane-adr">
                    <span className="AdditionalParametersPane-label">ADR</span>
                    <this.Control type="select" withoutLabel={ true }
                        options={
                            Object.values(parameters.adr.values)
                                .map(option => {
                                    return {
                                        value: option.is_default === 0 ? option.id : -1,
                                        label: option.value,
                                        is_default: option.is_default,
                                    }
                                })
                                .sort((a, b) => b.is_default - a.is_default)
                        }
                        attribute={parameters.adr}/>
                </div>
            );
        }

        var roundTrip = null;
        if (parameters.round_trip) {
            roundTrip = (
                <div style={{ minWidth: '400px' }} className="AdditionalParametersPane-field">
                    <this.Control
                        key="13"
                        type="checkbox"
                        label={ parameters.round_trip.title }
                        attribute={parameters.round_trip}
                    />
                    <Tip label={parameters.round_trip.tip} />
                </div>
            );
        }

        var stuffOnStuff = null;
        if (parameters.stuff_on_stuff) {
            stuffOnStuff = (
                <div className="AdditionalParametersPane-field">
                    <this.Control
                        style={{ display: 'flex', flexWrap: 'nowrap' }}
                        type="checkbox"
                        attribute={parameters.stuff_on_stuff}
                        label={parameters.stuff_on_stuff.title}
                        name={parameters.stuff_on_stuff} />
                </div>
            );
        }

        var connick = null;
        if (parameters.connick) {
            connick = (
                <div className="AdditionalParametersPane-field">
                    <this.Control
                        key="12"
                        type="checkbox"
                        label={ parameters.connick.title }
                        attribute={parameters.connick}/>
                </div>
            );
        }

        var minConnickNumber = null;
        if (parameters.min_connick_number) {
            minConnickNumber = (
                <div className="AdditionalParametersPane-field AdditionalParametersPane-minConnickNumber">
                    <span className="AdditionalParametersPane-label AdditionalParametersPane-minConnickNumberLabel">
                        { parameters.min_connick_number.title }
                    </span>
                    <this.Control
                        className="SelectControl-minConnickNumber"
                        type="select"
                        withoutLabel={ true }
                        options={
                            Object.values(parameters.min_connick_number.values)
                                .map(option => {
                                    return {
                                        value: option.is_default === 0 ? option.id : -1,
                                        label: option.value,
                                        is_default: option.is_default,
                                    }
                                })
                                .sort((a, b) => b.is_default - a.is_default)
                        }
                        attribute={parameters.min_connick_number}/>
                </div>
            );
        }

        var stuffInsurance = null;
        if (parameters.stuff_insurance) {
            stuffInsurance = (
                <div>
                    <div className="AdditionalParametersPane-field">
                        <this.Control
                            type="checkbox"
                            attribute={parameters.stuff_insurance}
                            label={parameters.stuff_insurance.title}
                            name={parameters.stuff_insurance}/>
                        <Tip className="ParametersScreen-helpBox"
                             label={parameters.stuff_insurance.tip}/>
                    </div>
                    <div style={{ display: 'flex', gap: '5px', alignItems: 'center', maxWidth: '300px' }}>
                        <InputControl
                            value={this.state.insuranceCargoCost}
                            style={{ maxWidth: '300px' }}
                            placeholder={parameters.insurance_cargo_cost.title}
                            disabled={!parameters.stuff_insurance.value}
                            onChange={this._onInsuranceCargoCostChange}
                        />
                        <Tip label={parameters.insurance_cargo_cost.tip}/>
                    </div>
                </div>
            );
        }

        var escort = null;
        if (parameters.escort && !this.props.showInstantBooking) {
            escort = (
                <div style={{ marginTop: '40px' }} className="AdditionalParametersPane-field">
                    <this.Control
                        type="number"
                        attribute={parameters.escort}
                        label={parameters.escort.title}
                        minValue={0}
                        name={parameters.escort}
                        className="AdditionalParametersPane-counterEscort" />
                    <Tip className="ParametersScreen-helpBox AdditionalParametersPane-tipEscort"
                         label={parameters.escort.tip} />
                </div>
            )
        }

        var needBelts = null;
        if (parameters.need_belts) {
            needBelts = (
                <div className="AdditionalParametersPane-field">
                    <this.Control
                        type="checkbox"
                        label={ parameters.need_belts.title }
                        attribute={parameters.need_belts}/>
                </div>
            );
        }

        var needPallets = null;
        if (parameters.need_pallets) {
            needPallets = (
                <div className="AdditionalParametersPane-field">
                    <this.Control
                        type="checkbox"
                        label={ parameters.need_pallets.title }
                        attribute={parameters.need_pallets}/>
                </div>
            );
        }

        var medicalBook = null;
        if (parameters.medical_book) {
            medicalBook = (
                <div className="AdditionalParametersPane-field">
                    <this.Control
                        key="9"
                        type="checkbox"
                        label={ parameters.medical_book.title }
                        attribute={parameters.medical_book}/>
                </div>
            );
        }

        var sealing = null;
        if (parameters.sealing) {
            sealing = (
                <div className="AdditionalParametersPane-field">
                    <this.Control
                        key="47"
                        type="checkbox"
                        label={ parameters.sealing.title }
                        attribute={parameters.sealing}/>
                </div>
            );
        }

        var sourceDocuments = null;
        if (parameters.documents) {
            sourceDocuments = (
                <div className="AdditionalParametersPane-field">
                    <SourceDocuments parameters={parameters}/>
                </div>
            )
        }

        var firstGroup = null;
        if (passing || outsized || holdStuff || tir || crm || t1 || adr || roundTrip || stuffOnStuff || connick) {
            firstGroup = (
                <div className="AdditionalParametersPane-miscGroup">
                    { passing }
                    { outsized }
                    { holdStuff }
                    { tir }
                    { crm }
                    { t1 }
                    { adr }
                    { roundTrip }
                    { stuffOnStuff }
                    { connick }
                    { minConnickNumber }
                    { needBelts }
                    { needPallets }
                    { sealing }
                </div>
            );
        }

        return (
            <div className="AdditionalParametersPane">
                <div className="AdditionalParametersPane-misc">
                    { firstGroup }
                    <div className="AdditionalParametersPane-miscGroup">
                        { stuffInsurance }
                        { escort }
                        { medicalBook }
                        { sourceDocuments }
                    </div>
                </div>
            </div>
        );
    }

}

class SourceDocuments extends Component {

    static propTypes = {
        parameters: PropTypes.objectOf(ParameterType).isRequired
    };

    componentWillMount() {
        if (this.props.parameters.documents.value && this.props.parameters.documents.value.length > 0) {
            this.setState({enabled: true});
        }
    }

    constructor(props) {
        super(props);
        this.Control = createControlFactory(ActionCreators.updateParameter);
        var options = new Set();
        var parameters = this.props.parameters.documents.value;

        if (parameters) {
            for (var i = 0; i < parameters.length; i++) {
                options.add(parameters[i]);
            }
        }

        this.state = {
            enabled: false,
            options: options
        };
    }

    _onModeChange = (event, value) => {
        var enabled = !this.state.enabled;
        var {options} = this.state;
        if (value) {
            ActionCreators.updateParameter({
                'documents': options.toJSON()
            });
        } else {
            ActionCreators.updateParameter({
                'documents': []
            });
        }

        this.setState({enabled});
    };

    _onOptionChange = (event, value) => {
        const name = parseInt(event.target.name);
        var {options} = this.state;
        if (value) {
            options.add(name);
        } else {
            options.delete(name);
        }

        ActionCreators.updateParameter({
            'documents': options.toJSON()
        });
    };

    render() {
        const parameters = this.props.parameters.documents.value;
        var documentsNecessary = false;

        if (parameters) {
            documentsNecessary = true;
        }

        return (
            <div className="SourceDocuments">
                <Checkbox
                    label="Необходимы первичные документы"
                    onChange={this._onModeChange}
                    value={documentsNecessary} />
                <div className={classNames([
                        'SourceDocuments-options',
                        {
                            'SourceDocuments-options--shown': this.state.enabled
                        }
                    ])}>
                    <Checkbox
                        className="SourceDocuments-field"
                        name={7}
                        label="Договор"
                        onChange={this._onOptionChange}
                        value={arrayContainsValue(parameters, [7])} />
                    <Checkbox
                        className="SourceDocuments-field"
                        name={8}
                        label="Опись"
                        onChange={this._onOptionChange}
                        value={arrayContainsValue(parameters, [8])} />
                    <Checkbox
                        className="SourceDocuments-field"
                        name={9}
                        label="ТТН"
                        onChange={this._onOptionChange}
                        value={arrayContainsValue(parameters, [9])} />
                    <Checkbox
                        className="SourceDocuments-field"
                        name={10}
                        label="Акты"
                        onChange={this._onOptionChange}
                        value={arrayContainsValue(parameters, [10])} />
                </div>
            </div>
        )
    }

}

export default AdditionalParametersPane;



// WEBPACK FOOTER //
// ./client/components/ParametersScreen/AdditionalParametersPane.js